import { render, staticRenderFns } from "./CourseTable.vue?vue&type=template&id=3bb796a2&scoped=true"
import script from "./CourseTable.vue?vue&type=script&lang=js"
export * from "./CourseTable.vue?vue&type=script&lang=js"
import style0 from "./CourseTable.vue?vue&type=style&index=0&id=3bb796a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb796a2",
  null
  
)

export default component.exports